import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary to-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
            Ready to Experience Our Technology?
          </h2>
          <p className="text-lg md:text-xl text-primary-foreground/90 mb-8">
            Start your pilot program today and see how our AI-powered analytics can transform your operations
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              variant="secondary" 
              size="lg"
              iconName="Rocket"
              iconPosition="left"
              className="bg-background text-primary hover:bg-background/90"
            >
              Start Pilot Program
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground/10"
            >
              Schedule Demo
            </Button>
          </div>

          <div className="grid md:grid-cols-3 gap-6 pt-12 border-t border-primary-foreground/20">
            <div className="text-center">
              <div className="flex justify-center mb-3">
                <div className="p-3 bg-primary-foreground/10 rounded-lg">
                  <Icon name="Headphones" size={32} className="text-primary-foreground" />
                </div>
              </div>
              <h3 className="font-semibold text-primary-foreground mb-2">24/7 Support</h3>
              <p className="text-sm text-primary-foreground/80">
                Dedicated technical support team available around the clock
              </p>
            </div>

            <div className="text-center">
              <div className="flex justify-center mb-3">
                <div className="p-3 bg-primary-foreground/10 rounded-lg">
                  <Icon name="GraduationCap" size={32} className="text-primary-foreground" />
                </div>
              </div>
              <h3 className="font-semibold text-primary-foreground mb-2">Training Included</h3>
              <p className="text-sm text-primary-foreground/80">
                Comprehensive training and onboarding for your team
              </p>
            </div>

            <div className="text-center">
              <div className="flex justify-center mb-3">
                <div className="p-3 bg-primary-foreground/10 rounded-lg">
                  <Icon name="Shield" size={32} className="text-primary-foreground" />
                </div>
              </div>
              <h3 className="font-semibold text-primary-foreground mb-2">Enterprise Security</h3>
              <p className="text-sm text-primary-foreground/80">
                Bank-grade security with compliance certifications
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;